{
  "$id": "module://participant-broadcast",
  "$schema": "wealthlane://schemas/domain",
  "title": "Participant Broadcast",
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "title": {
      "type": "string",
      "title": "Title",
      "widget": "text",
      "noBlank": true,
      "noDoubleSpace": true,
      "maxLength": 100
    },
    "messageTemplateId": {
      "type": "string",
      "title": "Message Template",
      "widget": "select",
      "format": "broadcast-template-id",
      "noBlank": true
    },
    "messageTemplate": {
      "type": "string",
      "title": "Message Template Label",
      "widget": "hidden"
    },
    "message": {
      "type": "string",
      "title": "Custom Message",
      "widget": "text",
      "noBlank": true
    },
    "addToTemplate": {
      "type": "boolean",
      "title": "Add to template (Optional)",
      "widget": "checkbox",
      "default": false
    },
    "startDate": {
      "type": "string",
      "title": "Start Date",
      "widget": "date",
      "format": "date",
      "minDate": "today"
    },
    "endDate": {
      "type": "string",
      "title": "End Date",
      "widget": "date",
      "format": "date"
    },
    "isActive": {
      "type": "boolean",
      "title": "Active",
      "widget": "checkbox",
      "default": true
    },
    "lockStartDate": {
      "type": "boolean",
      "title": "Lock Start Date",
      "widget": "hidden",
      "default": false
    }
  }
}
